import { MaterialIcon } from "@eusoft/webapp-ui/components/Icon";



export const Icons = {
    "sale-circuit": <MaterialIcon name="language" />,
    "sale-point": <MaterialIcon name="storefront" />,
    "product": <MaterialIcon name="shopping_cart" />,
    "payment-card": <MaterialIcon name="credit_card" />,
    "merchant": <MaterialIcon name="business_center" />,
    "options": <MaterialIcon name="settings" />,
    "device": <MaterialIcon name="smartphone" />,
    "home": <MaterialIcon name="home" />,
}